<template>
    <div :class="{'tree-sub-item': is_child}"
         :draggable="draggable"
         @dragstart.stop="drag_start"
         @dragenter.stop="is_drag_enter = true"
         @dragleave.stop="is_drag_enter = false"
         @dragend.stop="drag_stop"
         @dragover.stop="$event.preventDefault()"
         @drop.prevent.stop="drop"
         @click="$emit('click')">

        <div class="dropdown" :class="{'is-active': show_dropdown}"
             @mouseleave="show_dropdown = false" v-click-outside="click_outside">

            <div @click="$emit('open')"
                class="tree-item"
                 :class="{'active': is_drag_enter || is_active}">
                <div class="left-icon">
                    <i class="icon" :class="icon"></i>
                </div>

                <div class="text">
                    <slot></slot>
                </div>

                <div class="actions">
                    <slot name="action"></slot>
                    <i v-if="$slots['dropdown']"
                       class="icon fas fa-ellipsis-v is-pulled-right"
                       @click.stop="show_dropdown = !show_dropdown"></i>
                </div>

                <div class="is-clearfix"></div>
            </div>

            <div class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <slot name="dropdown"></slot>
                </div>
            </div>
        </div>

        <slot name="end"></slot>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ElementWrapper',
    props: ['id', 'kind', 'name', 'is_child', 'is_active', 'icon', 'draggable'],
    computed: mapState('tree', ['moving_element']),
    data() {
        return { is_drag_enter: false, show_dropdown: false };
    },
    methods: {
        close_dropdown() {
            this.show_dropdown = false;
        },
        click_outside() {
            this.$emit('click-outside');
        },
        drag_start() {
            this.$store.commit('tree/start_moving', {
                id: this.id,
                kind: this.kind,
                source: 'tree',
            });
        },
        drag_stop() {
            this.$store.commit('tree/stop_moving');
        },
        drop() {
            this.is_drag_enter = false;
            this.$emit('moved', this.moving_element);
        },
    },
};
</script>

<style scoped>
    .dropdown {
        display: block
    }

    .tree-item .fa-ellipsis-v {
        display: none;
    }

    .tree-item:hover .fa-ellipsis-v {
        display: -ms-inline-flexbox;
        display: inline-flex;
    }

    .dropdown .dropdown-menu {
        right: 0;
        left: auto;
        padding-top: 0;
        min-width: 5rem;
    }

    .tree-item {
        padding: 0.4rem;
        margin: 0.15rem;
        cursor: pointer;
    }

    .tree-item:hover {
        background: #e7e7e7;
        border-radius: 4px;
    }

    .tree-item.active {
        background: #e7e7e7;
        border-radius: 4px;
    }

    .tree-sub-item {
        margin-left: 1rem;
    }

    .text {
        display: inline;
        float: left;
        width: calc(100% - 4.2rem);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .left-icon {
        display: inline;
        float: left;
        width: 1.7rem;
    }

    .actions {
        display: inline;
        float: left;
        width: 2.5rem;
    }
</style>
